import find from 'lodash/find';
import each from 'lodash/each';
import uniqWith from 'lodash/uniqWith';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import replace from 'lodash/replace';
import filter from 'lodash/filter';
import toLower from 'lodash/toLower';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import concat from 'lodash/concat';
import intersection from 'lodash/intersection';
import map from 'lodash/map';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import { getFeatureflag } from 'yoda-core-components/lib/helpers/Utils/Utils';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import User from 'yoda-site-components/lib/helpers/User/User';
import { ACCOUNT_ID } from 'yoda-site-components/lib/common/Constants';
import TokenProvider, {
    setValue,
} from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { logDAError } from 'yoda-interfaces/lib/Order/OrderApi';
import CustomErrorLogger from 'yoda-site-components/lib/helpers/CustomErrorLogger/CustomErrorLogger';
import ScriptLoader from 'yoda-core-components/lib/helpers/ScriptLoader/ScriptLoader';

import {
    isSyndicateURL,
    createLogPayload,
    getURLParameterBykey,
    isOOSItem,
} from './ATCCommonUtils';
import {
    PAYPAL_URL_TEST,
    JCP_HOSTNAME_MOBILE,
    JCP_HOSTNAME_DESKTOP,
    JCP_HOSTNAME_UNIFIED,
    PAYPAL_URL_PROD,
    PAYPAL_FORCE_WEB,
    SHIPPING_GROUP_TYPE_HOME,
    URL_CART_PAGE,
    URL_REVIEW_PAGE,
    APPLEPAY_ERROR_MAP,
    APPLE_PAY_PAYMENT_RESTRICTED_COUPON_MESSAGE,
    allowedQueryParams,
    ADJUSTMENT_TYPE_NEW_CUSTOMER,
    MAXALLOWEDGIFTCARD,
} from '../../common/Constants';
import { DISCONTINUED_OOS_MESSAGES, OOS_MESSAGES } from '../../common/LabelConstants';

const queryStringToJSON = (queryParams) => {
    const pairs = queryParams.split('&');
    const result = {};
    pairs.forEach((pair) => {
        // eslint-disable-next-line no-param-reassign
        pair = pair.split('=');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    return JSON.parse(JSON.stringify(result));
};

export function navigateToPDPPageWithoutParams(item) {
    const url = get(item, 'product.url', '');
    try {
        if (isSyndicateURL(url)) {
            window.location.href = url;
        } else {
            const queryParams = url.split('?');
            let appendVal = '?';
            let queryParmaerters = '';
            /* istanbul ignore next */
            if (queryParams.length > 1) {
                const querParamObj = queryStringToJSON(queryParams[1]);
                forEach(allowedQueryParams, (params) => {
                    if (querParamObj[params]) {
                        queryParmaerters = `${queryParmaerters}${appendVal}${params}=${querParamObj[params]}`;
                        appendVal = '&';
                    }
                });
            }
            let pTitle = toLower(replace(item.product.name, /[^a-zA-Z ]/g, '')); // remove all special cahrs except space
            pTitle = toLower(replace(pTitle, /\s+/g, '-')); // replace spaces with '-'
            /* istanbul ignore next */
            window.location.href = `/p/${pTitle}/${item.product.id}${queryParmaerters}`;
        }
    } catch (ex) {
        /* istanbul ignore next */
        window.location.href = url;
    }
}

export function getPayPalUrl() {
    let urlPayPal = PAYPAL_URL_TEST;
    if (
        window.location.hostname === JCP_HOSTNAME_MOBILE ||
        window.location.hostname === JCP_HOSTNAME_DESKTOP ||
        window.location.hostname === JCP_HOSTNAME_UNIFIED
    ) {
        urlPayPal = PAYPAL_URL_PROD;
    }
    return urlPayPal;
}

export function navigateToPayPal(token) {
    const paypalUrl = getPayPalUrl();
    const paypalLink = `${paypalUrl}${token}${PAYPAL_FORCE_WEB}`;
    window.location.href = paypalLink;
}

export function getWarrantyDetails(selectedProductLot, selectedProtectionPlan) {
    const warranties = [];
    let includedProtectionPlan = [];
    if (get(selectedProductLot, 'warranties', []).length) {
        includedProtectionPlan = selectedProductLot.warranties.filter(
            (warranty) => warranty.selected
        );
        /* sort protection plans from BAPI based on price */
        selectedProductLot.warranties.sort(/* istanbul ignore next */ (a, b) => b.price - a.price);
        selectedProductLot.warranties.forEach((warranty) => {
            if (!warranty.selected) {
                warranties.push({
                    id: warranty.itemId,
                    type: 'service',
                    group: 'care plan',
                    required: true,
                    selected: warranty.itemId === selectedProtectionPlan,
                    name: warranty.name,
                    description: warranty.description,
                    price: warranty.price,
                });
            }
        });
    }
    return { warranties, includedProtectionPlan };
}

export function getCurrentProduct(items, skuId) {
    let services;
    const currentItem = filter(items, (item) => item.sku.id === skuId);
    const childItems = get(currentItem[0], 'childItems', []);
    if (!isEmpty(childItems)) {
        services = filter(childItems, (item) => item.type === 'SERVICE');
    }
    return services;
}

/**
 * This method will iterate through the provided orderItems object
 * and determine if the order contains a gift card
 * @static
 * @param {any} orderItems
 * @returns
 *
 * @memberof Utils
 */
export function isGiftCardOrder(orderItems) {
    let result = false;

    /* istanbul ignore else */
    if (orderItems && orderItems.length > 0) {
        each(orderItems, (item) => {
            /* istanbul ignore else */
            if (item.product && item.product.type === 'GIFTCARD') {
                result = true;
            }
        });
    }

    return result;
}

/**
 * This method will iterate through the provided orderItems object
 * and determine if the order contains not a gift card
 * @static
 * @param {any} orderItems
 * @returns
 *
 * @memberof Utils
 */
export function isGiftCardOrderOnly(orderItems) {
    let result = false;
    if (orderItems && orderItems.length > 0) {
        result = true;
        each(orderItems, (item) => {
            if (item.product && item.product.type !== 'GIFTCARD') {
                result = false;
            }
        });
    }
    return result;
}

export function isAddGiftCardLinkEligible(data) {
    const items = get(data, 'bag.items', []);
    const isGiftCardOrderCheck = isGiftCardOrder(items);
    if (isGiftCardOrderCheck) {
        return false;
    }
    const appliedGiftCard = get(data, 'billing.unnamed.giftCards', []);
    const totals = get(data, 'totals', []);
    const totalBalance = find(totals, { type: 'BALANCE' }) || {};
    return totalBalance.amount > 0 && appliedGiftCard.length < MAXALLOWEDGIFTCARD;
}

export function getClientId(deviceType, isNativeIos = false, isNativeAndroid = false) {
    let clientId = '';

    if (isNativeIos) {
        clientId = 'amNwLmlvczpETndDU1QyZHBi'; // ios App
    } else if (isNativeAndroid) {
        clientId = 'amNwLmFuZHJvaWQ6UDE2TENncmZjWQ'; // Android App
    } else if (deviceType.isDesktop) {
        clientId = 'amNwOnlvZGF3Ojc1NTU4NTk2';
    } else if (deviceType.isMobile) {
        clientId = 'amNwLnJ3ZG06QVVndFRydFc5cg';
    } else if (deviceType.isTablet) {
        clientId = 'amNwLnJ3ZHQ6Uk5hdVJqdUsycw';
    }
    return clientId;
}

/* istanbul ignore next */
export function getFormattedValue(offerReward) {
    let formattedValue = Number(offerReward);
    /* istanbul ignore else */
    // eslint-disable-next-line radix
    if (parseInt(formattedValue, 0) === offerReward) {
        formattedValue = formattedValue.toFixed();
    }
    return formattedValue.toString();
}

/**
 * Navigate user to Review page
 */
/* istanbul ignore next */
export function navigateToReview() {
    getBrowserHistory().push(URL_REVIEW_PAGE);
}

/**
 * This method set background to non scrollable state
 * @static
 * @param {any} status
 *
 * @memberof Utils
 */
export function setBackgroundPageFixed(status) {
    // Pass param to set background page to non scrollable
    /* istanbul ignore next */
    if (__SERVER__) {
        return;
    }
    if (status) {
        document.body.style.position = 'fixed';
        document.body.style.top = 0;
        document.body.style.bottom = 0;
        document.body.style.right = 0;
        document.body.style.left = 0;
        return;
    }
    // pass nothing/false to reset to scrollable
    document.body.style.position = 'inherit';
}

/**
 * return example: Apr 10
 * @param {d} date string
 */
export function getDateFormatMmmsDD(d, withYear = false, fullMonths = false) {
    try {
        let months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];

        const fullMonthsList = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        if (fullMonths) {
            months = fullMonthsList;
        }
        const date = new Date(d);
        const year = date.getFullYear();
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(date)) {
            return withYear
                ? `${months[date.getMonth()]} ${date.getDate()}, ${year}`
                : `${months[date.getMonth()]} ${date.getDate()}`;
        }
    } catch (ex) {
        // suppressed
    }
    return d;
}

export function getOrderGiftRegistries(orderDetails) {
    if (isEmpty(orderDetails)) {
        return null;
    }

    // initialize the object to be returned.
    const orderGiftRegistries = {
        itemsPresent: false,
        registries: [],
        items: [],
        shippingGroupId: null,
    };

    /* istanbul ignore else */
    if (
        orderDetails.delivery &&
        orderDetails.delivery.groups &&
        orderDetails.delivery.groups.length > 0
    ) {
        const deliveryGroup = find(orderDetails.delivery.groups, {
            type: SHIPPING_GROUP_TYPE_HOME,
        });
        deliveryGroup && (orderGiftRegistries.shippingGroupId = deliveryGroup.id);
    }

    // iterate through the bag items and update the gift registry item status.
    /* istanbul ignore else */
    if (orderDetails && orderDetails.bag && !isEmpty(orderDetails.bag.items)) {
        each(orderDetails.bag.items, (item) => {
            const arrayItem = {};
            arrayItem.itemId = item.id;
            arrayItem.manualGift = true; // assuming the item is a regular non gift registry item.

            /* istanbul ignore else */
            if (!isEmpty(item.giftRegistry)) {
                arrayItem.regId = item.giftRegistry.id;
                arrayItem.regName = item.giftRegistry.name;
                arrayItem.regType = item.giftRegistry.type;
                arrayItem.manualGift = false; // we know that the item was added from a gift registry.

                const registryItem = {};
                registryItem.id = item.giftRegistry.id;
                registryItem.name = item.giftRegistry.name;
                registryItem.type = item.giftRegistry.type;

                orderGiftRegistries.registries.push(registryItem);
                orderGiftRegistries.itemsPresent = true;
            }
            orderGiftRegistries.items.push(arrayItem);
        });
    }

    /* istanbul ignore else */
    if (orderGiftRegistries.itemsPresent) {
        orderGiftRegistries.registries = uniqWith(orderGiftRegistries.registries, isEqual);
    }

    orderGiftRegistries.registries &&
        orderGiftRegistries.registries.length !== 1 &&
        (orderGiftRegistries.itemsPresent = false);

    return orderGiftRegistries;
}

/*
 * This function will only return true or false based on OAuth token down or not.
 */
export function isTokenApiDown() {
    return (
        TokenProvider.get('TOKEN_API_STATUS') === 'true' ||
        TokenProvider.get('TOKEN_API_STATUS') === true
    );
}

/*
 * This function is to read the required cookies for cart merge and create custom headers object, to support Legacy adapter.
 * param: cookieList => Array of cookie names to read.
 */
export function getLegacyAdapterCookies(cookieList) {
    const customHeaders = {};
    each(cookieList, (cookie) => {
        const cookieValue = Cookies.load(cookie);
        /* istanbul ignore else */
        if (!isEmpty(cookieValue)) {
            customHeaders[cookie] = cookieValue;
        }
    });

    return customHeaders;
}

export function logDAErrorUtil(params) {
    logDAError(params);
}

export function getOrderID(digitalData) {
    /* istanbul ignore else */
    if (
        digitalData &&
        digitalData.transaction &&
        digitalData.transaction.attributes &&
        digitalData.transaction.attributes.transactionID
    ) {
        return digitalData.transaction.attributes.transactionID;
    }
    return 'NFOID';
}

export function logBootstrapPresentInSplunk(digitalData, enableClickStreamLogs) {
    try {
        const pageOCSPlunkAttributes = {
            name: 'BSTP',
            value: window.Bootstrapper ? 'Y' : 'N',
            type: 'string',
        };
        let payload2 = createLogPayload(pageOCSPlunkAttributes);
        const orderID = {
            name: 'OID',
            value: getOrderID(digitalData),
            type: 'string',
        };
        payload2 = createLogPayload(orderID, payload2);
        const params = { payload: payload2 };
        enableClickStreamLogs
            ? CustomErrorLogger.triggerCustomErrorLog(params)
            : logDAErrorUtil(params);
        return true;
    } catch (error) {
        /* istanbul ignore next */
        return false;
    }
}

export function getOrigin(checkoutState) {
    let origin = '';
    if (__SERVER__) {
        origin = 'checkout';
        return origin;
    }
    if (window.location.pathname === URL_CART_PAGE) {
        origin = 'cart';
        return origin;
    }
    if (window.location.pathname === URL_REVIEW_PAGE) {
        origin = 'review';
        return origin;
    }
    try {
        const sdpuIndex = checkoutState?.SDPU?.index || 0;
        const shippingIndex = checkoutState?.shipping?.index || 0;
        const paymentIndex = checkoutState?.payment?.index || 0;
        const selectedIndex = checkoutState?.selectedAccordionIndex || 0;
        switch (selectedIndex) {
            case sdpuIndex:
            case shippingIndex:
                origin = 'shipping';
                break;
            case paymentIndex:
                origin = 'billing';
                break;
            default:
                origin = 'checkout';
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('err during determine current accordion', err);
    }
    return origin;
}

export function logAdBlockerAndDNTInSplunk(digitalData, isBlockingAds, enableClickStreamLogs) {
    try {
        const TLTSID = {
            name: 'TLTSID',
            value: Cookies.load('TLTSID'),
            type: '',
        };
        let payload2 = createLogPayload(TLTSID);
        const orderId = {
            name: 'orderId',
            value: getURLParameterBykey('OrderId', window.location.href),
            type: '',
        };
        payload2 = createLogPayload(orderId, payload2);
        const jcpOrderID = {
            name: 'jcpOrderID',
            value: getOrderID(digitalData),
            type: '',
        };
        payload2 = createLogPayload(jcpOrderID, payload2);
        const userAgent = {
            name: 'userAgent',
            value: navigator.userAgent,
            type: '',
        };
        payload2 = createLogPayload(userAgent, payload2);
        const DPJSESSIONID = {
            name: 'DPJSESSIONID',
            value: Cookies.load('DPJSESSIONID'),
            type: '',
        };
        payload2 = createLogPayload(DPJSESSIONID, payload2);
        const AccountID = {
            name: 'ACCOUNT_ID',
            value: Cookies.load('ACCOUNT_ID'),
            type: '',
        };
        payload2 = createLogPayload(AccountID, payload2);
        const DNT = {
            name: 'DNT',
            value: navigator.doNotTrack,
            type: '',
        };
        payload2 = createLogPayload(DNT, payload2);
        const adBlocking = {
            name: 'ADBlock',
            value: isBlockingAds ? 'Y' : 'N',
            type: '',
        };
        payload2 = createLogPayload(adBlocking, payload2);
        const params = { payload: payload2 };
        enableClickStreamLogs
            ? CustomErrorLogger.triggerCustomErrorLog(params)
            : logDAErrorUtil(params);
        return true;
    } catch (/* istanbul ignore next */ error) {
        return false;
    }
}

/* istanbul ignore next */
export function AdBlockerTestandLog(digitalData) {
    try {
        const adBlockTester = document.createElement('div');
        adBlockTester.innerHTML = '&nbsp;';
        adBlockTester.className = 'adsbox';
        adBlockTester.height = '1px';
        adBlockTester.width = '1px';
        /* istanbul ignore next */
        window.setTimeout(
            () /* istanbul ignore next */ => {
                if (adBlockTester.offsetHeight === 0) {
                    setTimeout(() => {
                        // blocking ads
                        logAdBlockerAndDNTInSplunk(digitalData, true);
                    }, 1500);
                } else {
                    // not blocking ads
                    logAdBlockerAndDNTInSplunk(digitalData, false);
                }
                document.body.removeChild(adBlockTester);
            },
            1500
        );
        document.body.appendChild(adBlockTester);
        return true;
    } catch (/* istanbul ignore next */ error) {
        return false;
    }
}

/**
 * This method handles redirection to specific sections like shipping, payment or cart page based on
 * subCode returned by Aurora micro-services
 * @exceptions Object
 * @isReviewPage {true / false}
 *
 * @memberof Utils
 */
export function handleAuroraRedirection(exceptions, enableCheckoutRedesign) {
    // TODO Move these codes to config/preferences
    const billingErrorSubCodes = [
        'BILLING',
        'BILLING_GC',
        'BILLING_CC',
        'BILLING_PAYPAL',
        'BILLING_APPLEPAY',
    ];
    const shippingErrorSubCodes = ['DELIVERY', 'DELIVERY_STH', 'DELIVERY_STS'];
    if (!enableCheckoutRedesign) {
        shippingErrorSubCodes.push('DELIVERY_BOPIS');
    }
    let errorHandled = false;
    if (!isEmpty(exceptions)) {
        const errorSubCodes = map(exceptions, 'errorSubcode');
        // If errorSubCode has billing redirect user to billing
        /* istanbul ignore next */
        if (
            !isEmpty(intersection(billingErrorSubCodes, errorSubCodes)) &&
            isEmpty(intersection(shippingErrorSubCodes, errorSubCodes))
        ) {
            errorHandled = true;
        }
    }
    return errorHandled;
}

/**
 * Return static image path
 * @context Object
 * @imageName String
 */
export function imagePath(context = {}, imageName) {
    // NOSONAR
    // https://www.static-jcpenney.com/prod4/yoda-checkout/assets/static/images/icon-giftcard.svg
    return `${context?.staticRoutes?.app}/assets/static/images/${imageName}`;
}

export function getViewPort() {
    let viewportSize = '';
    if (window && window.innerWidth) {
        const width = window.innerWidth;
        if (width < 600) {
            viewportSize = 'small';
        } else if (width >= 600 && width < 1024) {
            viewportSize = 'medium';
        } else if (width >= 1024 && width < 1440) {
            viewportSize = 'large';
        } else {
            viewportSize = 'xlarge';
        }
    }
    return viewportSize;
}

export function setGlobalErrorHandler(section, actionCreator) {
    /* istanbul ignore next */
    const handler = (event) => {
        // setTimeout is needed here to handle global error after boundary component did it
        setTimeout(() => {
            const { error } = event;
            // eslint-disable-next-line no-underscore-dangle
            if (error && !error._boundaryAlreadyHandled) {
                const accountId = TokenProvider.get(ACCOUNT_ID);
                actionCreator([
                    {
                        name: `GLOBAL_ERROR_${section}_${accountId}`,
                        value: error.stack || 'Unhandled exception',
                    },
                ]);
            }
        });
    };

    window.addEventListener('error', handler);

    return () => window.removeEventListener('error', handler);
}

export function applepayUpdateConstructor(response) {
    const draftResp = response.data;
    const update = {
        newShippingMethods: [],
        newLineItems: [],
        newTotal: {
            label: 'JCPenney',
            amount: 0,
        },
    };
    let selectedShippingMethod = '';
    draftResp.totals.forEach((total) => {
        /* istanbul ignore else */
        if (total.type === 'SUB TOTAL') {
            update.newLineItems.push({
                label: total.type,
                amount: total.amount,
            });
        }
        /* istanbul ignore else */
        if (total.type === 'BALANCE') {
            update.newTotal.amount = total.amount;
        }
    });
    const rewards = {
        count: 0,
        amount: 0,
    };
    let paymentRestrictedCouponMessage = null;
    draftResp.adjustments.forEach((adj) => {
        /* istanbul ignore else */
        if (adj.rewardCategory === ADJUSTMENT_TYPE_NEW_CUSTOMER) {
            paymentRestrictedCouponMessage = APPLE_PAY_PAYMENT_RESTRICTED_COUPON_MESSAGE;
        }
        if (adj.code === 'COUPON' && adj.value && adj.amount) {
            if (!isEmpty(adj.message)) {
                paymentRestrictedCouponMessage = `${APPLE_PAY_PAYMENT_RESTRICTED_COUPON_MESSAGE} ${adj.value}`;
            }
            update.newLineItems.push({
                label: `DISCOUNT: ${adj.value}`,
                amount: -adj.amount,
            });
        }
        if (adj.code === 'ASSOCIATEDISCOUNT' && adj.amount) {
            update.newLineItems.push({
                label: 'DISCOUNT: ASSOC. DISCOUNT',
                amount: -adj.amount,
            });
        }
        if (adj.code === 'REWARDSCERT' && adj.value && adj.amount) {
            rewards.count += 1;
            rewards.amount += adj.amount;
        }
    });
    if (paymentRestrictedCouponMessage) {
        update.newLineItems.unshift({
            label: paymentRestrictedCouponMessage,
            amount: '0.0',
            type: 'pending',
        });
    }
    /* istanbul ignore else */
    if (rewards.amount) {
        const rewardLabel = rewards.count > 1 ? `REWARDS(${rewards.count})` : 'REWARD';
        update.newLineItems.push({
            label: `DISCOUNT: ${rewardLabel}`,
            amount: -rewards.amount,
        });
    }
    if (draftResp.delivery.groups) {
        const shippingGroup = draftResp.delivery.groups.filter((d) => d.type === 'HOME')[0];
        const serviceLevels = get(shippingGroup, 'serviceLevels.data');
        /* istanbul ignore else */
        if (serviceLevels) {
            serviceLevels.forEach((dMethod) => {
                /* istanbul ignore else */
                if (dMethod.code && dMethod.duration) {
                    update.newShippingMethods.push({
                        label: dMethod.code,
                        amount: dMethod.charge,
                        detail: dMethod.duration,
                        identifier: shippingGroup.id,
                        selected: dMethod.selected,
                    });
                    if (dMethod.selected) {
                        selectedShippingMethod = dMethod;
                    }
                }
            });
            update.newShippingMethods.sort((sMethod) => !sMethod.selected);
        }
    }
    const chargesUIMap = {
        'OVERSIZE SURCHARGE': 'OVERSIZED ITEM CHARGE',
        'ROUND UP': 'ROUND UP FOR CHARITY',
    };
    const chargesSort = ['SHIPPING AND HANDLING', 'OVERSIZE SURCHARGE', 'TAX', 'ROUND UP'];
    draftResp.charges.sort((a, b) => chargesSort.indexOf(a.type) - chargesSort.indexOf(b.type));
    draftResp.charges.forEach((charge) => {
        /* istanbul ignore else */
        if (charge.type && charge.amount !== 'TBD') {
            let label = chargesUIMap[charge.type] ? chargesUIMap[charge.type] : charge.type;
            if (charge.type === 'SHIPPING AND HANDLING' && selectedShippingMethod) {
                label = selectedShippingMethod.code;
            }
            update.newLineItems.push({
                label,
                amount: charge.amount,
            });
        }
    });
    const giftCards = get(draftResp, 'billing.unnamed.giftCards', []);
    if (!isEmpty(giftCards)) {
        let giftCardAmount = 0;
        let count = 0;
        giftCards.forEach((giftCard) => {
            giftCardAmount += giftCard.amount;
            count += 1;
        });
        const label = count > 1 ? `GIFT CARD (${count})` : 'GIFT CARD';
        update.newLineItems.push({
            label,
            amount: -giftCardAmount,
        });
    }
    return update;
}

/**
 * Construct apple error object list.
 * Should ignore apple pay payment related error.
 * @param errors
 * @return {Array}
 */
export function appleErrorConstructor(errors) {
    const applePayErrorList = [];
    forEach(errors, (error) => {
        let errorCode = null;
        let contactField = null;
        let errorMessage = error.errorMessage || '';
        if (
            error.errorSubcode === 'DELIVERY_STH' &&
            error.errorCode === 'API_ERR_FIELD_HOME_INTL_COUNTRY_NOT_SUPPORTED'
        ) {
            errorCode = 'addressUnserviceable';
            contactField = 'postalAddress';
        } else if (
            APPLEPAY_ERROR_MAP[error.errorSubcode] &&
            APPLEPAY_ERROR_MAP[error.errorSubcode][error.errorCode]
        ) {
            errorCode = APPLEPAY_ERROR_MAP[error.errorSubcode].code;
            const errorInfo = APPLEPAY_ERROR_MAP[error.errorSubcode][error.errorCode];
            contactField = errorInfo.contactField;
            if (errorInfo.messageOverride) {
                errorMessage = errorInfo.customErrMsg;
            }
        } else if (error.errorSubcode === 'DELIVERY_STH') {
            errorCode = 'shippingContactInvalid';
            contactField = 'postalAddress';
        }
        if (errorCode && contactField) {
            const applePayError = new window.ApplePayError(errorCode, contactField, errorMessage);
            applePayErrorList.push(applePayError);
        }
    });
    return applePayErrorList;
}

/**
 * updateUserZipcode, add or update DP_USER_DEFAULT_ADDRESS_ZIP cookie
 * @param cartDetailsResponse contains entire GET Order API Response
 * Help of this Add or Edit Address zipcode update into DP_USER_DEFAULT_ADDRESS_ZIP Cookie
 * Update if address country as US.
 */
export function updateUserZipcode(cartDetailsResponse) {
    const deliveryGroup = get(cartDetailsResponse, 'data.delivery.groups', []);
    // To get for BOPIS + STH || STH
    const shippingDeliveryGroup = find(deliveryGroup, { type: 'HOME' });
    const shippingAddressZipcode = get(shippingDeliveryGroup, 'address.zip', '');
    const shippingAddressCountry = get(shippingDeliveryGroup, 'address.country', '');
    !isEmpty(shippingAddressZipcode) &&
        (shippingAddressCountry === 'US' || shippingAddressCountry === 'AP') &&
        setValue('DP_USER_DEFAULT_ADDRESS_ZIP', shippingAddressZipcode, true);
}

/**
 * update DP_USER_DEFAULT_ADDRESS_ZIP cookie based STH item level zipcode
 * @param cartDetailsResponse contains entire GET Order API Response
 */
export function updateUserZipcodeBasedSTHItem(cartDetailsResponse) {
    const items = get(cartDetailsResponse, 'data.bag.items', []);
    let sthDeliveryInfo = {};
    find(items, (item) => {
        sthDeliveryInfo = find(item.deliveryOptions, { code: 'HOME', selected: true });
        return sthDeliveryInfo;
    });
    const shippingAddressZipcode = get(sthDeliveryInfo, 'zipcode');
    shippingAddressZipcode && setValue('DP_USER_DEFAULT_ADDRESS_ZIP', shippingAddressZipcode, true);
}

/**
 * getOrderShippingZipcode return order zipcode order has HOME shipping type
 * @param orderShippingGroupsInfo contains Shipping delivery Groups
 * Help of this return Order Zipcode to display on Cart & Checkout. Else to display AK Zipcode
 */
export function getOrderShippingZipcode(orderShippingGroupsInfo) {
    const STHShippingGroup = find(orderShippingGroupsInfo, { type: 'HOME' }) || {};
    return (
        (STHShippingGroup.address &&
            (STHShippingGroup.address.country === 'US' ||
                STHShippingGroup.address.country === 'AP') &&
            STHShippingGroup.address.zip) ||
        ''
    );
}

/**
 * getOrderShippingType return order type as "HOME | STORE | BOPIS"
 * @param orderShippingGroupsInfo contains Shipping delivery Groups
 * Help of this return Order type to display AK Zipcode on Cart & Checkout
 */
export function getOrderShippingType(orderShippingGroupsInfo) {
    let orderShippingType = '';
    forEach(orderShippingGroupsInfo, (group) => {
        if (orderShippingType) {
            if (group.type === 'BOPIS') {
                orderShippingType = `${group.type}|${orderShippingType}`;
            } else {
                orderShippingType = `${orderShippingType}|${group.type}`;
            }
        } else {
            orderShippingType = group.type;
        }
    });
    return orderShippingType;
}

/**
 * Check some of item is OOS or not
 * @param exceptions
 * @return {boolean}
 */
export function isSomeOfItemOOS(exceptions) {
    return !!find(exceptions, { errorCode: 'ORDER_HAS_OUT_OF_STOCK' });
}

/**
 * Check all item is OOS or not
 * @param exceptions
 * @return {boolean}
 */
export function isAllItemOOS(exceptions) {
    return !!find(exceptions, { errorCode: 'ALL_ITEMS_OUT_OF_STOCK' });
}

/**
 * Return order total amount
 * @param totals
 * @return {number}
 */
export function getOrderTotal(totals) {
    const orderAmountInfo = find(totals, { type: 'ORDER AMOUNT' }) || {};
    return orderAmountInfo.amount || 0.0;
}

export function mapOOSMessage(discontinuedOOSDetails, isAllItemsDiscontinuedAndOOS = false) {
    const {
        isOOS,
        isDiscontinued,
        isOOSSDPU,
        isBNPLItemOOS,
        isBnplOnOrder,
    } = discontinuedOOSDetails;
    let discontinuedOOSMessage = {};
    const isOOSSDPUItem = isOOS && isOOSSDPU;
    const isOOSNOSDPU = isOOS && !isOOSSDPU;
    if (isBnplOnOrder && !isAllItemsDiscontinuedAndOOS) {
        discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.OOS_NONBNPLITEM;
        if (isBNPLItemOOS) {
            discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.OOS_BNPLITEM;
        }
    } else if (isDiscontinued && !isOOS) {
        discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.DISCONTINUED_ITEMS;
    } else if (isDiscontinued && isOOSNOSDPU) {
        discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.DISCONTINUE_OOS_NOSDPU;
    } else if (!isDiscontinued && isOOSNOSDPU) {
        discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.OOS_NOSDPU;
    } else if (isDiscontinued && isOOSSDPUItem) {
        discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.DISCONTINUE_OOS_SDPU;
    } else if (!isDiscontinued && isOOSSDPUItem) {
        discontinuedOOSMessage = DISCONTINUED_OOS_MESSAGES.OOS_SDPU;
    } else {
        discontinuedOOSMessage = OOS_MESSAGES;
    }
    return discontinuedOOSMessage;
}

export function isBOPISItem(item = {}) {
    return find(item.deliveryOptions, {
        code: 'BOPIS',
        selected: true,
    });
}

export function getDataForOOS(items, isBnplOnOrder = false) {
    const discontinuedOOSDetails = {
        oosItemProducts: [],
        discontinuedItemProducts: [],
        discontinuedOOSMessage: {},
    };
    const OOSInfo = {
        isOOS: false,
        isDiscontinued: false,
        isOOSSDPU: false,
        isBNPLItemOOS: false,
    };

    map(items, (item) => {
        const { product, id: cartItemId, attributes } = item;
        const pushObj = { ...product, cartItemId, attributes };

        /* istanbul ignore else */
        if (item.discontinued) {
            discontinuedOOSDetails.discontinuedItemProducts.push(pushObj);
            OOSInfo.isDiscontinued = true;
        } else if (isOOSItem(item)) {
            discontinuedOOSDetails.oosItemProducts.push(pushObj);
            OOSInfo.isOOS = true;
            if (!OOSInfo.isOOSSDPU) {
                OOSInfo.isOOSSDPU = !!isBOPISItem(item);
            }
            if (isBnplOnOrder) {
                OOSInfo.isBnplOnOrder = isBnplOnOrder;
                if (item?.product?.buyNowPayLaterEligible) {
                    OOSInfo.isBNPLItemOOS = true;
                }
            }
        }
    });
    const isAllItemsOos = items.length === discontinuedOOSDetails.oosItemProducts.length;
    const isAllItemsDiscontinued =
        items.length === discontinuedOOSDetails.discontinuedItemProducts.length;
    const { oosItemProducts, discontinuedItemProducts } = discontinuedOOSDetails;
    const isAllItemsDiscontinuedAndOOS =
        items.length === concat(oosItemProducts, discontinuedItemProducts).length;
    discontinuedOOSDetails.discontinuedOOSMessage = mapOOSMessage(
        OOSInfo,
        isAllItemsDiscontinuedAndOOS
    );
    discontinuedOOSDetails.isBnplOnOrder = isAllItemsDiscontinuedAndOOS
        ? false
        : OOSInfo.isBnplOnOrder;
    const result = {
        isAllItemsOos,
        isAllItemsDiscontinued,
        discontinuedOOSDetails,
        isAllItemsDiscontinuedAndOOS,
    };
    return result;
}

/**
 * Return true if apple pay enabled and apple pay eligible from order api and balance is not 0 and not all item oos
 * @param context
 * @param orderResponse
 * @return {boolean}
 */
export function isOrderEligibleApplePay(context, orderResponse) {
    let orderEligibleApplePay = false;
    const isApplePayEnabled = get(context, 'featureFlags.applepay', true);
    if (isApplePayEnabled) {
        const availableStrategies = orderResponse.headers.get('X-AVAILABLE_STRATEGIES');
        const isOrderEligible =
            availableStrategies && availableStrategies.indexOf('apple-pay') !== -1;
        if (isOrderEligible) {
            const orderTotals = get(orderResponse, 'data.totals', []);
            const orderAmount = find(orderTotals, { type: 'BALANCE' });
            const orderBalanceExist = orderAmount && orderAmount.amount > 0;
            if (orderBalanceExist) {
                const discontinuedOOSInfo = getDataForOOS(orderResponse.data.bag.items);
                const {
                    isAllItemsDiscontinued,
                    isAllItemsOos,
                    isAllItemsDiscontinuedAndOOS,
                } = discontinuedOOSInfo;
                const enableDiscontinuedItemsMessaging = get(
                    context,
                    'featureFlags.enableDiscontinuedItemsMessaging',
                    true
                );
                const exceptions = get(orderResponse, 'data.status.exceptions', []);
                const isAllItemNotOOS = enableDiscontinuedItemsMessaging
                    ? !(isAllItemsDiscontinued || isAllItemsOos || isAllItemsDiscontinuedAndOOS)
                    : !isAllItemOOS(exceptions);
                if (isAllItemNotOOS) {
                    orderEligibleApplePay = true;
                }
            }
        }
    }
    return orderEligibleApplePay;
}

export function isPayPalStrategiesAvailable(orderResponse) {
    const availableStrategies = orderResponse.headers.get('X-AVAILABLE_STRATEGIES');
    return availableStrategies && availableStrategies.indexOf('paypal') !== -1;
}

/**
 * MCYODA-21044
 * Return true if cart BOPIS item has curbsidePickUpAvailable as true or ocp STORE item has curbsidePickUpAvailable as true
 * @param orderItems
 * @return {boolean}
 */
export function getCurbsideEligible(orderItems = [], pageName) {
    if (isEmpty(orderItems)) {
        return false;
    }
    const curbSideItem = find(orderItems, (item) => {
        const isCurbSideStoreExistInDelivery = find(
            item.deliveryOptions,
            (option) =>
                option.selected &&
                (option.code === 'BOPIS' || (option.code === 'STORE' && pageName === 'ocp')) &&
                option.curbsidePickUpAvailable
        );
        return !!isCurbSideStoreExistInDelivery;
    });
    return !!curbSideItem;
}

export function isNewBOPISmessageEnabled() {
    const akamaiThrottlingCookie = Cookies.load('DPCPT');
    const akamaiThrottlingCookieList = akamaiThrottlingCookie && akamaiThrottlingCookie.split('|');
    return akamaiThrottlingCookieList && akamaiThrottlingCookieList.includes('CP5Y');
}

/**
 * Return true if login as register user else return false
 * @param 'context-header-cookie-DP_USER_STATE'.
 * @return {boolean}
 */
export function checkUserLoggedIn(context) {
    /* istanbul ignore else */
    if (__SERVER__) {
        return get(context, 'headers.cookies.DP_USER_STATE', '') === '1';
    }
    return User.isUserLoggedIn();
}

export function handleCartExceptions(exception) {
    const bagError = find(exception, { errorCode: 'SRV_BAG_NOTFOUND', errorSubcode: 'BAG' });
    if (bagError) {
        window.location.href = '/cart';
    }
}

export function isDiscontinuedItem(orderItem) {
    return orderItem && orderItem.discontinued;
}

export function isShipAloneAvailable(items) {
    return !isEmpty(
        find(items, (item) => !isBOPISItem(item) && get(item, 'product.shipAlone', false))
    );
}

export function isDistantBillingAddress(warnings, codeType) {
    return !isEmpty(find(warnings, { code: codeType }));
}

export function getCartItemById(items = [], id = '') {
    return items.find((item) => item.id === id);
}

export function displayNortonSealEvent() {
    try {
        const e = new CustomEvent('displayNortonSeal', {});
        document.dispatchEvent(e);
    } catch (err) {
        /* istanbul ignore next */ /* eslint-disable-next-line no-console */
        console.log(err);
    }
}

export function getDeviceInfo() {
    const deviceInfo = {};
    // eslint-disable-next-line no-underscore-dangle
    if (window?._bcn?.dvc) {
        // eslint-disable-next-line no-underscore-dangle
        deviceInfo.deviceTransactionId = window._bcn.dvc.getTID();
    }
    // eslint-disable-next-line no-underscore-dangle
    if (window?._bcn) {
        // eslint-disable-next-line no-underscore-dangle
        deviceInfo.ubaToken = window._bcn.getToken();
        // eslint-disable-next-line no-underscore-dangle
        deviceInfo.ubaSessionId = window._bcn.getUbaSessionId();
        // eslint-disable-next-line no-underscore-dangle
        deviceInfo.ubaPageId = window._bcn.getPageId();
        // eslint-disable-next-line no-underscore-dangle
        deviceInfo.ubaEvents = window._bcn.getEvents();
    }
    return deviceInfo;
}

export function startAccertify(accertifyConfig, logError, errorSource) {
    const dpOrderId = Cookies.load('DPOrder');
    const quantumMetricSessionID = Cookies.load('QuantumMetricSessionID') || '';
    try {
        const startTime = performance.now();
        const onSuccess = () => {
            const callbackTime = performance.now();
            // eslint-disable-next-line no-console
            console.log(`Successfully loaded accertify script: ${callbackTime - startTime}`);
        };
        const onError = () => {
            logError(
                'Error in accertify script load',
                `${errorSource} | user-agent:${window?.navigator?.userAgent} | dpOrderId:${dpOrderId} | quantumSessionID: ${quantumMetricSessionID} | error: Failed to load external resource at ${accertifyConfig.src}`
            );
        };
        ScriptLoader.loadAccertify({
            ...accertifyConfig,
            sid: dpOrderId,
            onSuccess,
            onError,
        });
    } catch (e) {
        logError(
            'Exception in accertify script load',
            `${errorSource} | user-agent:${window?.navigator?.userAgent} | dpOrderId:${dpOrderId} | quantumSessionID: ${quantumMetricSessionID} | error: ${e.message}`
        );
    }
}

export function getCartEventData(items = []) {
    const cartArray = items.map((item) => {
        const price = find(item?.totals, { name: 'ITEM AMOUNT' });
        return {
            pprID: item?.product?.id,
            quantity: item?.quantity,
            price: price?.amount || '0.0',
            skuid: item?.sku?.id,
        };
    });
    return cartArray;
}
export function convertMillisecondsToCT(milliseconds) {
    const timezoneOffset = new Date().getTimezoneOffset();
    let result = milliseconds;
    // check if existing timezone is not CT then convert
    if (timezoneOffset !== 300) {
        const date = new Date(milliseconds);
        // Convert the date to Central Time (CT) using toLocaleString with the America/Chicago time zone
        const centralTime = date.toLocaleString('en-US', {
            timeZone: 'America/Chicago',
            hour12: false,
        });
        result = new Date(centralTime).getTime();
    }
    return result;
}

export function syncCouponExpireLSandPayload(couponExpireFromPayload) {
    const lSCouponExpire = TokenProvider.get('couponExpireNudgeClosed') || '[]';
    const lsCouponData = lSCouponExpire ? JSON.parse(lSCouponExpire) : lSCouponExpire;
    // Create a Set from lsCouponData for faster lookups
    const array2Set = new Set(lsCouponData);

    // Sync couponExpireFromPayload based on lsCouponData
    couponExpireFromPayload.forEach((item) => {
        if (array2Set.has(item.value)) {
            // If lsCouponData contains the name, add `isNudgeClosed` to the corresponding item in couponExpireFromPayload
            // eslint-disable-next-line no-param-reassign
            item.isNudgeClosed = true;
        }
    });

    // Remove values from lsCouponData that don't exist in couponExpireFromPayload
    // lsCouponData = lsCouponData.filter((name) => {
    //     return couponExpireFromPayload.some((item) => item.value === name);
    // });

    // Add to lsCouponData the names from couponExpireFromPayload that have `isNudgeClosed` (if not already present)
    couponExpireFromPayload.forEach((item) => {
        if (item.isNudgeClosed && !array2Set.has(item.value)) {
            lsCouponData.push(item.value);
        }
    });

    return { updatedCouponExpireData: couponExpireFromPayload, updatedLsCouponData: lsCouponData };
}

export function isClientB2BLogged() {
    const enableB2BVoucher = getFeatureflag('enableB2BVoucher');
    let isB2BClient = false;
    const aqccountType = TokenProvider.get('ACCOUNT_TYPE', true);
    if (enableB2BVoucher && aqccountType === 'B2B_VOUCHER') {
        isB2BClient = true;
    }
    return isB2BClient;
}

export function isSentToAgencyFromCart(b2bContext) {
    const enableB2BVoucher = getFeatureflag('enableB2BVoucher');
    let isSendToAgency = false;
    const isSentToAgencyCookie =
        b2bContext?.headers?.cookies?.isSendToAgency ||
        b2bContext?.isSendToAgency ||
        TokenProvider.get('isSendToAgency', true);
    if (enableB2BVoucher && isSentToAgencyCookie === 'true') {
        isSendToAgency = true;
    }
    return isSendToAgency;
}

export function rejectOrder() {
    const enableB2BVoucher = getFeatureflag('enableB2BVoucher');
    let isRejectOrder = false;
    const isRejectOrderCookie = TokenProvider.get('isRejectOrder', true);
    if (enableB2BVoucher && isRejectOrderCookie) {
        isRejectOrder = true;
    }
    return isRejectOrder;
}
